import authAxios from 'src/modules/shared/axios/authAxios';

export default class QuizQuestionService {
  static async update(id, data) {
    const body = {
      data,
    };

    if (body.data && Array.isArray(body.data.answers)) {
      body.data.answers = body.data.answers.map(answer => {
        const { errors, ...rest } = answer;
        return rest;
      });
    }
    
    const response = await authAxios.put(`/quiz-question/${id}`, body);

    return response.data;
  }

  static async destroyAll(ids) {
    const params = { ids };

    const response = await authAxios.delete(`/quiz-question`, { params });

    return response.data;
  }

  static async createBulk(quizId, data) {
    const body = {data};    

    const response = await authAxios.post(`/quiz-question/${quizId}/bulk`, body);

    return response.data;
  }

  static async create(data) {
    const body = {data};    
    if (body.data && Array.isArray(body.data.answers)) {
      body.data.answers = body.data.answers.map(answer => {
          const { id, errors, ...rest } = answer;
          return rest;
      });
    }

    const response = await authAxios.post(`/quiz-question`, body);

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/quiz-question/${id}`);    
    
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/quiz-question`, { params });
    
    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(`/quiz-question/unarchive`, body);

    return response.data;
  }
}
